import api from "@/helpers/api";
import type { AccessibilityStatement } from "../routes/statement/types/statement";

type SaveStatementData = AccessibilityStatement & {
  isPreview?: boolean;
};

export const getStatement = async () => {
  return await api.get({ path: "/statement" });
};

export const saveStatement = async (config: AccessibilityStatement, options?: { preview?: boolean }) => {
  const data: SaveStatementData = { ...config };
  if (options?.preview) {
    data.isPreview = true;
  }
  return await api.post({ path: "/statement", data });
};
